export interface OrgEdge {
  evaluatorId: number;
  evaluateeId: number;
  roleInEval: string;
  evaluatorName: string;
  evaluateeName: string;
  templateId?: number;
}

export interface OrgPersonRef {
  id: number;
  name: string;
}

export interface OrgPreview {
  batchId: number;
  currentSnapshotId: number | null;
  currentSnapshotVersion: number | null;
  orgVersion: string;
  /** 有在职员工但批次里没有对应素质模板的池——这些人会被生成流程整体跳过 */
  missingPools: Array<{ pool: string; memberCount: number }>;
  organizationDiff: {
    added: OrgPersonRef[];
    removed: OrgPersonRef[];
    changed: OrgPersonRef[];
  };
  desired: OrgEdge[];
  subordinateCandidates: Array<{
    evaluateeId: number;
    evaluateeName: string;
    candidates: Array<{
      evaluatorId: number;
      evaluatorName: string;
      evaluateeId: number;
      evaluateeName: string;
    }>;
  }>;
  additions: OrgEdge[];
  restorations: OrgEdge[];
  templateUpdates: OrgEdge[];
  removals: OrgEdge[];
  conflicts: OrgEdge[];
  protected: OrgEdge[];
  exclusions: Array<{
    evaluatorId: number;
    evaluateeId: number;
    evaluateeName: string;
    evaluatorName: string;
    roleInEval: string;
    reason: string | null;
  }>;
}

export interface OrgConfirmResult {
  snapshotId: number;
  version: number;
  created: number;
  restored: number;
  voided: number;
  templateUpdated: number;
  unchanged: boolean;
}

export function edgeKey(edge: {
  evaluateeId: number;
  evaluatorId: number;
  roleInEval: string;
}): string {
  return `${edge.evaluateeId}|${edge.evaluatorId}|${edge.roleInEval}`;
}
